var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
// https://html.spec.whatwg.org/multipage/syntax.html#void-elements
const VOID_ELEMENTS = [
    'area',
    'base',
    'br',
    'col',
    'embed',
    'hr',
    'img',
    'input',
    'link',
    'meta',
    'source',
    'track',
    'wbr'
];
function renderNodes(nodes) {
    if (!nodes) {
        return '';
    }
    if (typeof nodes === 'string') {
        return nodes;
    }
    return nodes.reduce((result, node) => {
        if (node.type === 'text') {
            result += node.text;
        }
        else if (node.name) {
            result += `<${node.name}`;
            if (node.attrs) {
                for (const key in node.attrs) {
                    result += ` ${key}="${node.attrs[key]}"`;
                }
            }
            result += '>';
            if (!VOID_ELEMENTS.includes(node.name)) {
                if (node.children) {
                    result += renderNodes(node.children);
                }
                result += `</${node.name}>`;
            }
        }
        return result;
    }, '');
}
const RichText = (_a, ref) => {
    var { className, nodes, selectable } = _a, rest = __rest(_a, ["className", "nodes", "selectable"]);
    const props = useTaroBaseEvents(rest);
    return (_jsx("div", Object.assign({ ref: ref, className: classNames(className, {
            'taro-rich-text__selectable': selectable
        }), dangerouslySetInnerHTML: {
            __html: renderNodes(nodes)
        } }, props)));
};
export default forwardRef(RichText);
